/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_3_DescInputs */

const en_mk_loop_3_desc = /** @type {(inputs: Mk_Loop_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the local workflow, your coding agent works on your project locally. Automatic mode uses Bystep’s server environment.`)
};

const id_mk_loop_3_desc = /** @type {(inputs: Mk_Loop_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pada alur mandiri, agent coding mengerjakan tugas di proyek lokal. Mode otomatis menggunakan lingkungan server Bystep.`)
};

/**
* | output |
* | --- |
* | "In the local workflow, your coding agent works on your project locally. Automatic mode uses Bystep’s server environment." |
*
* @param {Mk_Loop_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_3_desc = /** @type {((inputs?: Mk_Loop_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_3_desc(inputs)
	return en_mk_loop_3_desc(inputs)
});